import { loadScript } from './utils';

const initValidation = ($containers) => {
	$containers.each(function(index, container) {
		const $container = $(container);
		const $form = $('form', $container);
		const $select = $('.select select');

		$form.validate({
			errorElement: 'span',
			errorClass: 'error',
			validClass: 'success',
			ignore: [],

			errorPlacement: function(error, element) {
				if (element.is('select:hidden')) {
			        error.insertAfter(element.next('.nice-select'));
			    }
		    	else if (element.is(':checkbox')) {
		            error.insertAfter(element.closest('.checkbox'));
		        }
		        else if (element.is(':radio')) {
		            error.insertAfter(element.closest('.radios'));
		        }
			    else {
			        error.insertAfter(element);
			    }
			},

			highlight: function (element, errorClass, validClass) {
				$(element).closest('.form__row').addClass(errorClass);
				$form.addClass(errorClass);
			},

			unhighlight: function (element, errorClass, validClass) {
				$(element).closest('.form__row').removeClass(errorClass);
				$form.removeClass(errorClass);
			},

			submitHandler: function(form,event) {
				event.preventDefault();
				$(form).trigger('GalaxyEventForm');
				$.post(window._dynamic_base + '/lead/' + window.websiteID, $form.serialize())
					.then(function (data) {
						$container.addClass('success')
					}).fail(function () {
						$container.addClass('error');
					})
					.then(() => {
					if (container.querySelector('.form-success'))
						container.querySelector('.form-success').hidden = false;
					}).fail(() => {
						if (container.querySelector('.form-error'))
							container.querySelector('.form-error').hidden = false;
					}).always(() => {
						form.hidden = true;

					if (form.hasAttribute('data-file')) {
						if ($(window).width() < 768) {
							let elementId = form.getAttribute('data-file');
							window.location.href = elementId;
						}
						else {
							window.open(form.getAttribute('data-file'));
						}
					}
				})
			}
		});

		$select.on('change', function() {
			$(this).valid();
		});
	});
}

export default function formsUI() {
	loadScript('validateScript', window.validateScript, function() {
		return new Promise((resolve, reject) => {
			initValidation($('.js-form'));

			resolve();
		})
	})
}
